//@flow
import withHandledContractData from "../../../pages/Contracts/contracts/ContractCard/withHandledContractData";
import AddContractRow from "./AddContractRow";

const ConnectedAddContractRow = withHandledContractData(AddContractRow);
export default ConnectedAddContractRow;